<template>
  <div class="content">
    <div class="bodycontent">
      <div style="margin-bottom: 15px">
        <el-button size="small" @click="getData()" type="primary">刷新</el-button>
      </div>
      <div class="table_box">
        <el-table :data="tableData" border :header-cell-style="setTableHeader">
          <el-table-column label="任务名称" prop="text"></el-table-column>
          <el-table-column label="创建时间" prop="show_time"></el-table-column>
          <el-table-column label="状态" prop="show_status"></el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <el-button @click="continueItem(scope.row.id)" type="text" v-if="scope.row.status == 0">继续执行</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { couponTaskList,continueTask } from '@/api/vip';
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      tableData: [], // 表格数据
      page: 1, // 页码
      total: 0, // 总数
    }
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(){
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      }
      couponTaskList(data).then(res => {
        if(res.code == 200){
          console.log(res.data)
          this.tableData = res.data.data;
          this.tableData.forEach(item => {
            item.show_time = this.mydateFormat(item.create_time);
            item.show_status = item.status == 0? '正在执行':'已完成';
          })
          this.total = res.data.total;
        }else{
          this.$message(res.msg)
        }
      })
    },
    continueItem(id){
      var data = {
        app_id: this.app_id,
        task_id: id
      }
      continueTask(data).then(res => {
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "执行成功"
          })
        }else{
          this.$message(res.msg);
        }
      })
    },
    handleCurrentChange(val){
      this.page = val;
      this.getData();
    }
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 20px;
    font-size: 14px;
    background: #fff; 
  }
  .pagination{
    margin-top: 15px
  }
}
</style>